import { defineStore } from 'pinia'
import commonApi from '@/api/common'
import router from '@/router/index'
import { homePage } from '@/router/homePageRoutes'
import webRoutes from '@/router/webRoutes'
import tool from '@/utils/tool'
import useTagStore from './tags'

const useUserStore = defineStore('user', {
  state: () => ({
    avatar: undefined,
    btnMenu: undefined,
    name: undefined,
    sysMenu: undefined,
    routers: undefined
  }),
  actions: {
    setInfo(data) {
      this.$patch(data)
    },
    setMenu(data) {
      homePage.children = webRoutes[0].children
      this.sysMenu = arrToTree(data)
      this.sysMenu.unshift(homePage)
    },
    setRoutes(data) {
      const routers = filterAsyncRouter(data)
      routers.map((item) => router.addRoute('layout', item))
    },
    getUserInfo() {
      return new Promise(async (resolve, reject) => {
        const res = await commonApi.getUserInfo()
        if (res.code === 200) {
          this.setInfo(res.data)
          this.setRoutes(res.data.sysMenu)
          this.setMenu(res.data.sysMenu)
          resolve(res)
        }
      })
    },
    logOut() {
      const tagStore = useTagStore()
      tool.local.clear()
      tagStore.reset()
      this.$reset()
      router.push('/login')
    }
  }
})

const views = import.meta.glob('../../views/**/**.vue')

// 菜单转换路由
const filterAsyncRouter = (routerMap) => {
  const accessedRouters = []
  routerMap.forEach((item) => {
    if (item.menuType === 2) {
      const route = {
        path: item.path,
        name: item.code,
        meta: {
          icon: item.icon,
          title: item.name
        },
        component: views[`../../views${item.component}.vue`]
      }
      accessedRouters.push(route)
    }
  })
  return accessedRouters
}

//拍平数组转树形结构
const arrToTree = (arr: any[]): any[] => {
  const itemMap = {}
  arr.forEach((item) => {
    itemMap[item.id] = { ...item, meta: { title: item.name, icon: item.icon, is_show: item.is_show } }
  })

  const resultArr = []
  arr.forEach((item) => {
    const parent = itemMap[item.parentId]
    if (parent) {
      if (parent.children) {
        parent.children.push(itemMap[item.id])
      } else {
        parent.children = [itemMap[item.id]]
      }
    } else if (item.parentId === 0) {
      resultArr.push(itemMap[item.id])
    }
  })

  const sortNodes = (nodes: any) => {
    nodes.sort((a, b) => a.sort - b.sort)
    nodes.forEach((node) => {
      if (node.children && node.children.length > 0) {
        sortNodes(node.children)
      }
    })
  }

  sortNodes(resultArr)
  return resultArr
}

export default useUserStore
